import { jsx as _jsx } from "react/jsx-runtime";
import { Tabs as AntdTabs } from 'antd';
import { Icon } from '../icons/icon.js';
/** The overflow «more» button's accessible name. */
export const TABS_MORE_LABEL = 'زبانه‌های بیشتر';
export function Tabs({ moreIcon, addIcon, removeIcon, ...rest }) {
    return (_jsx(AntdTabs, { ...rest, 
        // The glyph is the overflow button's ONLY content (rc-tabs gives the
        // button no label, and `more={{ 'aria-label' }}` lands on the Dropdown,
        // not the button), so a labelled icon is what names it.
        moreIcon: moreIcon === undefined ? _jsx(Icon, { name: "more", size: 16, label: TABS_MORE_LABEL }) : moreIcon, addIcon: addIcon === undefined ? _jsx(Icon, { name: "add", size: 16 }) : addIcon, removeIcon: removeIcon === undefined ? _jsx(Icon, { name: "close-square", size: 16 }) : removeIcon }));
}
Tabs.TabPane = AntdTabs.TabPane;
//# sourceMappingURL=tabs.js.map